import React from "react"
import { TECH_STACK_LIST } from "../../data"
import "./style.scss"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

function HomeTechsCarousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 3,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplaySpeed: 1000,
        },
      },
    ],
  }

  return (
    <div className="container mb-5 pb-5 homeTechCarousel">
      <Slider {...settings}>
        {TECH_STACK_LIST.map((i, ind) => (
          <div
            className="d-flex justify-content-center align-items-center"
            key={ind}
          >
            <img loading="lazy"  src={i} alt="" className="img-fluid" />
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default HomeTechsCarousel
